import { Controller } from "@hotwired/stimulus"
import { throttle } from 'lodash-es'

export default class extends Controller {
  static values = {
    minY: String,
    className: String,
    throttleDelay: Number
  }

  initialize () {
    this.handleScroll = this.handleScroll.bind(this)
  }

  connect () {
    this.minValue = this.minYValue || 130
    this.className = this.classNameValue || 'is-scrolling'
    const throttleDelay = this.throttleDelayValue || 15
    this.handleScroll = throttleDelay > 0 ? throttle(this.handleScroll, throttleDelay) : this.handleScroll
  }

  handleScroll () {
    this.element.classList.toggle(this.className, window.scrollY > this.minValue)
  }
}
